import { useQuery } from "@tanstack/react-query";
import { useHospitalData } from "../contexts/HospitalDataProvider";
import { backendService } from "../services/backend.service";
import type { NurseCostItem } from "../utils/models";
import { useRevealWage } from "./useRevealWage";

type UseNurseCostsArgs = {
	date?: string;
	startDate?: string;
	endDate?: string;
	nurseIds?: number[];
};

export const useNurseCosts = ({ date, startDate, endDate, nurseIds }: UseNurseCostsArgs = {}) => {
	const { chosenDepartment } = useHospitalData();
	const canViewWage = useRevealWage();
	const departmentId = chosenDepartment.department_id;
	const hasDateInput = !!(date || (startDate && endDate));
	const enabled = canViewWage && hasDateInput;
	return useQuery<NurseCostItem[]>({
		queryKey: ["pto-costs", departmentId, date, startDate, endDate, nurseIds],
		queryFn: async () => {
			const { data } = await backendService.getPtoCosts(departmentId, date, nurseIds, startDate, endDate);
			return data.costs;
		},
		enabled,
	});
};
